// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tab-col[data-v-461f11dd] {\n    position: relative;\n}\n.custom-pagination[data-v-461f11dd] {\n    position: absolute;\n    bottom: 2px;\n    width: 100%;\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
